import React from 'react';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';

import { SummarizeWithAIResults } from './SummarizeWithAIResults';

export const SummarizeWithAIDrawer = ({ results = [], onClose, open = true, title, subheader }) => {
  const hasResults = Array.isArray(results) && results.length > 0;

  return (
    <FPDrawer
      CardHeaderProps={{
        title,
        subheader
      }}
      FPDrawerProps={{
        open,
        onClose
      }}
      onClose={onClose}
    >
      {hasResults ? <SummarizeWithAIResults results={results} /> : null}
    </FPDrawer>
  );
};
